import { render, staticRenderFns } from "./OrganizationTournaments.vue?vue&type=template&id=7f314352&scoped=true"
import script from "./OrganizationTournaments.vue?vue&type=script&lang=js"
export * from "./OrganizationTournaments.vue?vue&type=script&lang=js"
import style0 from "./OrganizationTournaments.vue?vue&type=style&index=0&id=7f314352&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f314352",
  null
  
)

export default component.exports